import React from 'react'

import SubtractIcon from 'Assets/Images/icons/subtract'
import {
  StyledWrapper,
  StyledTitle,
  StyledContent,
} from '../UploadSuccess/styles'
import {
  StyledIconWrapper,
  StyledInfo,
  StyledChildrenWrapper,
  StyledTimestampTemplate,
  StyledBold,
} from './styles'

const ValidationError = ({
  title,
  content,
  showTimestampTemplate,
  info = undefined,
  children,
}) => (
  <StyledWrapper>
    <StyledIconWrapper>
      <SubtractIcon />
    </StyledIconWrapper>
    <StyledTitle>{title}</StyledTitle>
    {content && <StyledContent>{content}</StyledContent>}
    {showTimestampTemplate && (
      <StyledTimestampTemplate>
        <p>
          <StyledBold>USA</StyledBold>: MM/DD/YYYY HH:mm:ss
        </p>
        <p>
          <StyledBold>Rest of world</StyledBold>: DD/MM/YYYY HH:mm:ss
        </p>
      </StyledTimestampTemplate>
    )}
    {info && <StyledInfo>{info}</StyledInfo>}
    <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
  </StyledWrapper>
)

export default ValidationError
